import React, { useEffect, useState, useMemo } from "react";
import "../styles/Components/RecordCRUD.scss";
import { useSelector, useDispatch } from "react-redux";
import { CRUDRecordPopup } from "../Redux/Slice/rootSlice";
import { useNavigate } from "react-router-dom";
import { postPatientReport, postRecordsData } from "../Redux/Thunk/Actions";
import Swal from "sweetalert2";
function RecordCRUD(props) {
  // console.log(props.prescriptionid_share,props.patientid_share,"id_share")
  const [fileData, setFileData] = useState();
  const [image, setImage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onImageChange = (event) => {
    console.log(event,"imggggsgsgs");
    
    if (event.target.files && event.target.files[0]) {
      let files_new = event.target.files[0];
      setFileData(files_new);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };
  const [dataSend, setDataSend] = useState({
    description: "",
  });
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handletest = async () => {
    // console.log(valueChange)
    closeUserPopup()
    props.loaderchange("true")
    console.log(props.patientData)
    try {
      if (                                
        props.patientData.p_uhid !== "" 

      ) {
        // if(valueChange.patientId2!==""){
        //     if( valueChange.patientId1 !== valueChange.patientId2){
        //     return false;
        //   }else{
        //     return true;
        //   }
        // }
        // Dispatch action to check couple id
        // const patentReportResponse = await dispatch(
        //   coupleIdChecker({
        //     payload: {
        //       patient_one: valueChange.patientId1,
        //       patient_two: valueChange.patientId2,
        //     },
        //   })
        // );

        // if (patentReportResponse.payload.status.code === 200) {
        //   // Set couple id in state
        //   setvalueChange((prevState) => ({
        //     ...prevState,
        //     coupleId: patentReportResponse.payload.data.couple_id,
        //   }));

       
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // console.log(valueChange.coupleId);
          // Get HTML payload
        //   const htmlPayload = document.getElementById("reportcreate").innerHTML;

          // Prepare payload for creating report
          const payload = {
            report_template:"",
            patient_id: props.patientData.id,
            description: "",
            template_type: "Added Report",
          };
          console.log(payload);
          // Dispatch action to create patient report
          props.loaderchange(true);
          // console.log(valueChange)
          let formData = new FormData();
    formData.append("files",fileData);
    formData.append("patient_id",props.patientData.id)
    formData.append("template_type","Added Report")
    formData.append("description",dataSend.description)

    // formData.append("data", JSON.stringify(payload));

    // console.log(formData.entries,"iiiiiiiiiiiiiiiiiiiikkook")

          const reportResponse = await dispatch(
            postPatientReport({ type: "2", payload: formData })
          );

          if (reportResponse?.payload?.status?.code === 200) {
            // props.loaderchange(false);
            // navigate("/patientreports");

            // Show success message
            Swal.fire({
              title: "Successful.",
              text: "Report added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
    props.loaderchange("false")

          } else {
            // setshow(false);

            props.loaderchange(false);

            // Show error message
            // props.popupalert(true);
            // props.popuptext("Network went wrong, Please try after some time.");

            // Hide error message after timeout
            setTimeout(() => {
            //   props.popupalert(false);
            }, 2000);
          }
        }, 3000);
        // } else {
        //   // Show error message if couple id check fails
        //   setshow(false);

        //   Swal.fire({
        //     title: "Error.",
        //     text: "you have done some thing wrong.",
        //     icon: "error",
        //     showConfirmButton: false,
        //     timer: 1500,
        //   });
        // }
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const dataupdate = (e) => {
    setDataSend({
      ...dataSend,
      [e.target.name]: e.target.value,
    });
  };
  const closeUserPopup = () => {
    props.setclosepopup(false);
    dispatch(CRUDRecordPopup(false));
  };
  // console.log(dataSend,'dataSend')
  //   console.log(fileData, "test");
  return (
    <>
      <div className="record_prescription">
        <div className="modal-dialog_record" role="document">
          <div class="modal-content modelContentChanges">
            <div class="modal-header">
              <h5 class="modal-title">Add Report</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => closeUserPopup(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div
              class="modal-body modelBodyChanges"
              style={{ padding: "1rem", width: "920px" }}
            >
              <form onSubmit={handleSubmit}>
                <div class="row">
                  <div class="col-3 title-input">
                    <label
                      for="validationCustom01"
                      style={{ fontSize: "18px" }}
                      class="form-label"
                    >
                      <span style={{ color: "red" }}>*</span>Upload file
                    </label>
                    {image != null && (
                      <img
                        alt="preview image"
                        style={{
                          width: "250px",
                          height: "200px",
                          paddingBottom: "20px",
                        }}
                        src={image}
                      />
                    )}
                    <input
                      type="file"
                      onChange={onImageChange}
                      //   multiple="multiple" //To select multiple files
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div className="col-12">
                    <label
                      for="validationCustom01"
                      style={{ fontSize: "18px" }}
                      class="form-label"
                    >
                      Description
                    </label>
                    <textarea
                      class="form-control inputStyleChange"
                      value={dataSend.description}
                      name="description"
                      style={{ height: "100px" }}
                      onChange={(e) => {
                        dataupdate(e);
                      }}
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary  create mt-3"
                  onClick={(e) => handletest(e)}
                >
                  Create Record
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RecordCRUD;
